
// src/components/PlatformIcon.js
import React from 'react';
import { normalizePlatform } from './Formatting';

/**
 * Platform Icon component - Renders the appropriate icon for different platforms
 * @param {string} platform - The platform name to display an icon for
 * @returns {JSX.Element} - The platform icon component
 */
const PlatformIcon = ({ platform }) => {
  if (!platform || typeof platform !== 'string') {
    return (
      <div className="platform-icon">
        <i className="fa-solid fa-globe"></i>
      </div>
    );
  }
  
  // Normalize the platform name
  const normalizedPlatform = normalizePlatform(platform);
  
  switch (normalizedPlatform) {
    case 'discord':
      return (
        <div className="platform-icon discord">
          <i className="fa-brands fa-discord"></i>
        </div>
      );
    case 'snapchat':
      return (
        <div className="platform-icon snapchat">
          <i className="fa-brands fa-snapchat"></i>
        </div>
      );
    case 'instagram':
      return (
        <div className="platform-icon instagram">
          <i className="fa-brands fa-instagram"></i>
        </div>
      );
    case 'tiktok':
      return (
        <div className="platform-icon tiktok">
          <i className="fa-brands fa-tiktok"></i>
        </div>
      );
    case 'reddit':
      return (
        <div className="platform-icon reddit">
          <i className="fa-brands fa-reddit-alien"></i>
        </div>
      );
    default:
      return (
        <div className="platform-icon">
          <i className="fa-solid fa-globe"></i>
        </div>
      );
  }
};

export default PlatformIcon;